import * as React from 'react';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="h-dvh w-full flex overflow-hidden">
      {/* Left side - Form (scrollable) */}
      <div className="flex-1 overflow-y-auto flex flex-col items-center p-8">
        <div className="w-full max-w-md my-auto py-8">
          {/* Logo */}
          <Link to="/" className="flex items-end justify-center gap-2 mb-8">
            <img src="/volovolo.png" alt="Volovolo" className="h-10 w-auto" />
            <span className="font-bold text-xl">Pro</span>
          </Link>

          {children}
        </div>
      </div>

      {/* Right side - Image/Branding */}
      <div className="hidden lg:flex flex-1 bg-primary p-12 items-center justify-center overflow-y-auto">
        <div className="max-w-md text-primary-foreground">
          <h2 className="text-3xl font-bold mb-4">
            Gérez votre boutique en ligne facilement
          </h2>
          <p className="text-primary-foreground/80 text-lg">
            Volovolo Pro vous permet de gérer vos commandes, produits, promotions
            et bien plus encore depuis une seule interface.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-primary-foreground" />
              <span>Gestion des commandes</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-primary-foreground" />
              <span>Catalogue produits</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-primary-foreground" />
              <span>Promotions & codes</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-primary-foreground" />
              <span>Statistiques détaillées</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
